/**
 * Off-Canvas toggle component
 *
 * Usage:
 *   <div data-toggle="off-canvas" data-target="#offCanvas">Open</div>
 *   <div class="off-canvas position-right" id="offCanvas">...</div>
 *   <div class="off-canvas-overlay" data-close="off-canvas"></div>
 */
export function initOffCanvas() {
  // Toggle buttons
  document.querySelectorAll('[data-toggle="off-canvas"]').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const targetSelector = trigger.getAttribute('data-target');
      const panel = targetSelector ? document.querySelector(targetSelector) : null;
      if (!panel) return;

      const isOpen = panel.classList.contains('is-open');
      if (isOpen) {
        closeOffCanvas(panel);
      } else {
        openOffCanvas(panel);
      }
    });
  });

  // Overlay close
  document.querySelectorAll('[data-close="off-canvas"]').forEach(overlay => {
    overlay.addEventListener('click', () => {
      const openPanel = document.querySelector('.off-canvas.is-open');
      if (openPanel) {
        closeOffCanvas(openPanel);
      }
    });
  });

  // Close on Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const openPanel = document.querySelector('.off-canvas.is-open');
      if (openPanel) {
        closeOffCanvas(openPanel);
      }
    }
  });
}

function openOffCanvas(panel) {
  panel.classList.add('is-open');
  const overlay = document.querySelector('.off-canvas-overlay');
  if (overlay) overlay.classList.add('is-visible');
  document.body.style.overflow = 'hidden';
}

function closeOffCanvas(panel) {
  panel.classList.remove('is-open');
  const overlay = document.querySelector('.off-canvas-overlay');
  if (overlay) overlay.classList.remove('is-visible');
  document.body.style.overflow = '';
}
